import React from "react";
import AbnormalOrderRecordType from "@/enum/AbnormalOrderRecordType";
import { Form, Popover } from "antd";
import AbnormalOrderRecordTypeNameMap from "@/map/AbnormalOrderRecordTypeNameMap";
import EcSelect from "@/components/EcSelect";
import { observer } from "mobx-react-lite";
import { QuestionCircleOutlined } from "@ant-design/icons";

interface AbnormalOrderRecordTypeFieldProps {}

const AbnormalOrderRecordTypeField: React.FC<AbnormalOrderRecordTypeFieldProps> = function (props) {
    const data = Object.values(AbnormalOrderRecordType).map((abnormalOrderRecordType) => {
        if (
            [
                AbnormalOrderRecordType.ORDER_ITEM_CANCELED_AFTER_SHIPPED,
                AbnormalOrderRecordType.ORDER_CANCELED_AFTER_SHIPPED,
            ].includes(abnormalOrderRecordType)
        ) {
            return {
                label: (
                    <span>
                        <span>{AbnormalOrderRecordTypeNameMap[abnormalOrderRecordType]}</span>
                        <Popover
                            content={
                                <span className="inline-block w200">
                                    {AbnormalOrderRecordTypeNameMap[abnormalOrderRecordType]}
                                    严格按照每个店铺设置的情况进行搜索，比如店铺设置发货后24小时内订单发生变成生成异常，则搜索出来的就是发货后24小时内有异常的订单
                                </span>
                            }
                            placement="right"
                            zIndex={9999}
                        >
                            <QuestionCircleOutlined className="ml5" />
                        </Popover>
                    </span>
                ),
                value: abnormalOrderRecordType,
            };
        }

        return {
            label: AbnormalOrderRecordTypeNameMap[abnormalOrderRecordType],
            value: abnormalOrderRecordType,
        };
    });

    return (
        <Form.Item name="abnormalOrderRecordTypes" label={<span className="search-field-label">异常类型</span>}>
            <EcSelect
                multiple
                data={data}
                renderResult={(abnormalOrderRecordTypes: AbnormalOrderRecordType[]) =>
                    abnormalOrderRecordTypes.map((it) => AbnormalOrderRecordTypeNameMap[it]).join()
                }
            />
        </Form.Item>
    );
};

export default observer(AbnormalOrderRecordTypeField);
